export default __webpack_public_path__ + "static/media/8.e862c49f.png";